import { useEffect, useState } from 'react';
import { formatTime } from '../lib/format';

// Зворотній відлік. Викликає onExpire коли дійшов до 0.
export function Timer({
  totalSeconds,
  onExpire,
}: {
  totalSeconds: number;
  onExpire: () => void;
}) {
  const [left, setLeft] = useState(totalSeconds);

  useEffect(() => {
    const tick = setInterval(() => {
      setLeft((s) => {
        if (s <= 1) {
          clearInterval(tick);
          onExpire();
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(tick);
  }, [onExpire]);

  // Червоний коли менше 30 секунд — щоб привернути увагу
  const danger = left < 30;
  return (
    <div
      className={`rounded-lg px-2 py-1 text-sm font-mono tabular-nums ${
        danger ? 'bg-tg-destructive text-white' : 'bg-tg-secondary-bg text-tg-text'
      }`}
    >
      {formatTime(left)}
    </div>
  );
}
